import XEUtils from 'xe-utils';
import { VxeUI } from '../../ui';
import { getClass } from '../../ui/src/utils';
import { getCellHeight, convertHeaderColumnToRows } from './util';
const { renderer, renderEmptyElement } = VxeUI;
const cellType = 'header';
const renderRows = (h, _vm, isGroup, isOptimizeMode, cols, $rowIndex) => {
    const props = _vm;
    const $xeTable = _vm.$parent;
    const $xeGrid = $xeTable.xegrid;
    const tableProps = $xeTable;
    const tableReactData = $xeTable;
    const tableInternalData = $xeTable;
    const { fixedType } = props;
    const { resizable: allResizable, columnKey, headerCellClassName, headerCellStyle, showHeaderOverflow: allColumnHeaderOverflow, headerAlign: allHeaderAlign, align: allAlign, mouseConfig } = tableProps;
    const { currentColumn, dragCol, scrollXLoad, scrollYLoad, overflowX } = tableReactData;
    const { scrollXStore } = tableInternalData;
    const columnOpts = $xeTable.computeColumnOpts;
    const columnDragOpts = $xeTable.computeColumnDragOpts;
    const cellOpts = $xeTable.computeCellOpts;
    const defaultRowHeight = $xeTable.computeDefaultRowHeight;
    const headerCellOpts = $xeTable.computeHeaderCellOpts;
    const currCellHeight = getCellHeight(headerCellOpts.height || cellOpts.height) || defaultRowHeight;
    const { disabledMethod: dragDisabledMethod, isCrossDrag, isPeerDrag } = columnDragOpts;
    return cols.map((column, $columnIndex) => {
        const { type, showHeaderOverflow, headerAlign, align, filters, headerClassName, editRender, cellRender } = column;
        // const { enabled } = tooltipOpts
        const colid = column.id;
        const renderOpts = editRender || cellRender;
        const compConf = renderOpts ? renderer.get(renderOpts.name) : null;
        const isColGroup = column.children && column.children.length;
        const fixedHiddenColumn = fixedType ? column.fixed !== fixedType && !isColGroup : column.fixed && overflowX;
        const isPadding = XEUtils.isBoolean(headerCellOpts.padding) ? headerCellOpts.padding : cellOpts.padding;
        const headOverflow = XEUtils.isUndefined(showHeaderOverflow) || XEUtils.isNull(showHeaderOverflow) ? allColumnHeaderOverflow : showHeaderOverflow;
        const headAlign = headerAlign || (compConf ? compConf.tableHeaderCellAlign : '') || allHeaderAlign || align || (compConf ? compConf.tableCellAlign : '') || allAlign;
        let showEllipsis = headOverflow === 'ellipsis';
        const showTitle = headOverflow === 'title';
        const showTooltip = headOverflow === true || headOverflow === 'tooltip';
        let hasEllipsis = showTitle || showTooltip || showEllipsis;
        let hasFilter = false;
        let firstFilterOption = null;
        if (filters) {
            firstFilterOption = filters[0];
            hasFilter = filters.some((item) => item.checked);
        }
        const columnIndex = $xeTable.getColumnIndex(column);
        const _columnIndex = $xeTable.getVTColumnIndex(column);
        const cellParams = { $table: $xeTable, $grid: $xeGrid, $rowIndex, column, columnIndex, $columnIndex, _columnIndex, firstFilterOption, fixed: fixedType, type: cellType, isHidden: fixedHiddenColumn, hasFilter };
        const thAttrs = {
            colid,
            colspan: column.colSpan > 1 ? column.colSpan : null,
            rowspan: column.rowSpan > 1 ? column.rowSpan : null
        };
        const thOns = {
            click: (evnt) => $xeTable.triggerHeaderCellClickEvent(evnt, cellParams),
            dblclick: (evnt) => $xeTable.triggerHeaderCellDblclickEvent(evnt, cellParams)
        };
        // 虚拟滚动不支持动态高度
        if (scrollXLoad && !hasEllipsis) {
            showEllipsis = hasEllipsis = true;
        }
        const isColDragCell = columnOpts.drag && columnDragOpts.trigger === 'cell';
        let isDisabledDrag = false;
        if (isColDragCell) {
            isDisabledDrag = !!(dragDisabledMethod && dragDisabledMethod(cellParams));
        }
        // 按下事件处理
        if (mouseConfig || isColDragCell) {
            thOns.mousedown = (evnt) => $xeTable.triggerHeaderCellMousedownEvent(evnt, cellParams);
        }
        // 拖拽列事件
        if (columnOpts.drag) {
            thOns.dragstart = $xeTable.handleHeaderCellDragDragstartEvent;
            thOns.dragend = $xeTable.handleHeaderCellDragDragendEvent;
            thOns.dragover = $xeTable.handleHeaderCellDragDragoverEvent;
            if (isColDragCell) {
                thOns.mouseup = $xeTable.handleHeaderCellDragMouseupEvent;
            }
        }
        const isLastColumn = $columnIndex === cols.length - 1;
        const showResizable = (XEUtils.isBoolean(column.resizable) ? column.resizable : (columnOpts.resizable || allResizable));
        const isAutoCellWidth = !column.resizeWidth && (column.minWidth === 'auto' || column.width === 'auto');
        let isVNPreEmptyStatus = false;
        if (!isGroup) {
            if (!dragCol || dragCol.id !== colid) {
                if (scrollXLoad && !column.fixed && (_columnIndex < scrollXStore.visibleStartIndex - scrollXStore.preloadSize || _columnIndex > scrollXStore.visibleEndIndex + scrollXStore.preloadSize)) {
                    isVNPreEmptyStatus = true;
                }
            }
        }
        const tcStyle = {};
        if (hasEllipsis) {
            tcStyle.height = `${currCellHeight}px`;
        }
        else {
            tcStyle.minHeight = `${currCellHeight}px`;
        }
        return h('th', {
            class: ['vxe-header--column', colid, {
                    [`col--${headAlign}`]: headAlign,
                    [`col--${type}`]: type,
                    'col--last': isLastColumn,
                    'col--fixed': column.fixed,
                    'col--group': isColGroup,
                    'col--ellipsis': hasEllipsis,
                    'fixed--width': !isAutoCellWidth,
                    'fixed--hidden': fixedHiddenColumn,
                    'is--padding': isPadding,
                    'is--sortable': column.sortable,
                    'col--filter': !!filters,
                    'is--filter-active': hasFilter,
                    'is--drag-active': columnOpts.drag && !column.fixed && !isDisabledDrag && (isCrossDrag || isPeerDrag || !column.parentId),
                    'is--drag-disabled': columnOpts.drag && isDisabledDrag,
                    'col--current': currentColumn === column
                }, getClass(headerClassName, cellParams), getClass(headerCellClassName, cellParams)],
            attrs: thAttrs,
            style: headerCellStyle ? (XEUtils.isFunction(headerCellStyle) ? headerCellStyle(cellParams) : headerCellStyle) : undefined,
            on: thOns,
            key: columnKey || scrollXLoad || scrollYLoad || columnOpts.useKey || columnOpts.drag || isColGroup ? colid : $columnIndex
        }, [
            h('div', {
                class: ['vxe-cell', {
                        'c--title': showTitle,
                        'c--tooltip': showTooltip,
                        'c--ellipsis': showEllipsis
                    }],
                style: tcStyle
            }, isVNPreEmptyStatus || (isOptimizeMode && fixedHiddenColumn)
                ? []
                : [
                    h('div', {
                        attrs: {
                            colid
                        },
                        class: 'vxe-cell--wrapper'
                    }, column.renderHeader(h, cellParams))
                ]),
            /**
           * 列宽拖动
           */
            !fixedHiddenColumn && showResizable
                ? h('div', {
                    class: 'vxe-cell--col-resizable',
                    on: {
                        mousedown: (evnt) => $xeTable.handleColResizeMousedownEvent(evnt, fixedType, cellParams),
                        dblclick: (evnt) => $xeTable.handleColResizeDblclickEvent(evnt, cellParams)
                    }
                })
                : renderEmptyElement($xeTable)
        ]);
    });
};
function renderHeads(h, _vm, isGroup, isOptimizeMode, headerGroups) {
    const props = _vm;
    const $xeTable = _vm.$parent;
    const tableProps = $xeTable;
    const tableReactData = $xeTable;
    const { fixedType } = props;
    const columnOpts = $xeTable.computeColumnOpts;
    const columnDragOpts = $xeTable.computeColumnDragOpts;
    const { headerRowClassName, headerRowStyle } = tableProps;
    const { isColLoading, isDragColMove } = tableReactData;
    return headerGroups.map((cols, $rowIndex) => {
        const params = { $table: $xeTable, $rowIndex, fixed: fixedType, type: cellType };
        if (!isColLoading && columnOpts.drag && columnDragOpts.animation) {
            return h('transition-group', {
                key: $rowIndex,
                props: {
                    tag: 'tr',
                    name: `vxe-header--col-list${isDragColMove ? '' : '-disabled'}`,
                    class: [
                        'vxe-header--row',
                        headerRowClassName ? XEUtils.isFunction(headerRowClassName) ? headerRowClassName(params) : headerRowClassName : ''
                    ],
                    style: headerRowStyle ? (XEUtils.isFunction(headerRowStyle) ? headerRowStyle(params) : headerRowStyle) : null
                }
            }, renderRows(h, _vm, isGroup, isOptimizeMode, cols, $rowIndex));
        }
        return h('tr', {
            key: $rowIndex,
            class: [
                'vxe-header--row',
                headerRowClassName ? XEUtils.isFunction(headerRowClassName) ? headerRowClassName(params) : headerRowClassName : ''
            ],
            style: headerRowStyle ? (XEUtils.isFunction(headerRowStyle) ? headerRowStyle(params) : headerRowStyle) : undefined
        }, renderRows(h, _vm, isGroup, isOptimizeMode, cols, $rowIndex));
    });
}
export default {
    name: 'VxeTableHeader',
    props: {
        tableData: Array,
        tableColumn: Array,
        tableGroupColumn: Array,
        fixedColumn: Array,
        fixedType: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            headerColumn: []
        };
    },
    watch: {
        tableColumn() {
            this.uploadColumn();
        }
    },
    created() {
        this.uploadColumn();
    },
    mounted() {
        const _vm = this;
        const props = _vm;
        const $xeTable = _vm.$parent;
        const internalData = $xeTable;
        const { fixedType } = props;
        const { elemStore } = internalData;
        const prefix = `${fixedType || 'main'}-header-`;
        elemStore[`${prefix}wrapper`] = _vm.$refs.refElem;
        elemStore[`${prefix}scroll`] = _vm.$refs.refHeaderScroll;
        elemStore[`${prefix}table`] = _vm.$refs.refHeaderTable;
        elemStore[`${prefix}colgroup`] = _vm.$refs.refHeaderColgroup;
        elemStore[`${prefix}list`] = _vm.$refs.refHeaderTHead;
        elemStore[`${prefix}xSpace`] = _vm.$refs.refHeaderXSpace;
        elemStore[`${prefix}repair`] = _vm.$refs.refHeaderBorderRepair;
    },
    destroyed() {
        const props = this;
        const $xeTable = this.$parent;
        const internalData = $xeTable;
        const { fixedType } = props;
        const { elemStore } = internalData;
        const prefix = `${fixedType || 'main'}-header-`;
        elemStore[`${prefix}wrapper`] = null;
        elemStore[`${prefix}scroll`] = null;
        elemStore[`${prefix}table`] = null;
        elemStore[`${prefix}colgroup`] = null;
        elemStore[`${prefix}list`] = null;
        elemStore[`${prefix}xSpace`] = null;
        elemStore[`${prefix}repair`] = null;
    },
    render(h) {
        const props = this;
        const $xeTable = this.$parent;
        const tableProps = $xeTable;
        const tableReactData = $xeTable;
        const tableInternalData = $xeTable;
        const { xID } = $xeTable;
        const { fixedType, fixedColumn, tableColumn } = props;
        const { headerColumn } = this;
        const { mouseConfig, showHeaderOverflow: allColumnHeaderOverflow, spanMethod, footerSpanMethod } = tableProps;
        const { isGroup, overflowX, scrollXLoad, scrollYLoad, dragCol } = tableReactData;
        const { visibleColumn, fullColumnIdData } = tableInternalData;
        const mouseOpts = $xeTable.computeMouseOpts;
        let renderHeaderList = headerColumn;
        let renderColumnList = tableColumn;
        let isOptimizeMode = false;
        if (isGroup) {
            renderColumnList = visibleColumn;
        }
        else {
            // 如果是使用优化模式
            if (scrollXLoad || scrollYLoad || allColumnHeaderOverflow) {
                if (spanMethod || footerSpanMethod) {
                    // 如果不支持优化模式
                }
                else {
                    isOptimizeMode = true;
                }
            }
            if (fixedType || !overflowX) {
                renderColumnList = visibleColumn;
            }
            if (fixedType) {
                // 如果是使用优化模式
                if (isOptimizeMode) {
                    renderColumnList = fixedColumn || [];
                }
            }
            renderHeaderList = [renderColumnList];
        }
        if (!fixedType && !isGroup) {
            // 列拖拽
            if (scrollXLoad && dragCol) {
                if (renderColumnList.length > 2) {
                    const dCowRest = fullColumnIdData[dragCol.id];
                    if (dCowRest) {
                        const dcIndex = dCowRest._index;
                        const firstCol = renderColumnList[0];
                        const lastCol = renderColumnList[renderColumnList.length - 1];
                        const firstColRest = fullColumnIdData[firstCol.id];
                        const lastColRest = fullColumnIdData[lastCol.id];
                        if (firstColRest && lastColRest) {
                            const fcIndex = firstColRest._index;
                            const lcIndex = lastColRest._index;
                            if (dcIndex < fcIndex) {
                                renderColumnList = [dragCol].concat(renderColumnList);
                                renderHeaderList = [[dragCol].concat(renderHeaderList[0])].concat(renderHeaderList.slice(1));
                            }
                            else if (dcIndex > lcIndex) {
                                renderColumnList = renderColumnList.concat([dragCol]);
                                renderHeaderList = [renderHeaderList[0].concat([dragCol])].concat(renderHeaderList.slice(1));
                            }
                        }
                    }
                }
            }
        }
        return h('div', {
            ref: 'refElem',
            class: ['vxe-table--header-wrapper', fixedType ? `fixed-${fixedType}--wrapper` : 'body--wrapper'],
            attrs: {
                xid: xID
            }
        }, [
            h('div', {
                ref: 'refHeaderScroll',
                class: 'vxe-table--header-inner-wrapper',
                on: {
                    scroll(evnt) {
                        $xeTable.triggerHeaderScrollEvent(evnt, fixedType);
                    }
                }
            }, [
                fixedType
                    ? renderEmptyElement($xeTable)
                    : h('div', {
                        ref: 'refHeaderXSpace',
                        class: 'vxe-body--x-space'
                    }),
                h('table', {
                    ref: 'refHeaderTable',
                    class: 'vxe-table--header',
                    attrs: {
                        xid: xID,
                        cellspacing: 0,
                        cellpadding: 0,
                        border: 0
                    }
                }, [
                    /**
                     * 列宽
                     */
                    h('colgroup', {
                        ref: 'refHeaderColgroup'
                    }, renderColumnList.map((column, $columnIndex) => {
                        return h('col', {
                            attrs: {
                                name: column.id
                            },
                            key: $columnIndex
                        });
                    })),
                    /**
                     * 头部
                     */
                    h('thead', {
                        ref: 'refHeaderTHead'
                    }, renderHeads(h, this, isGroup, isOptimizeMode, renderHeaderList)),
                    mouseConfig && mouseOpts.area
                        ? h('div', {
                            class: 'vxe-table--cell-area'
                        }, [
                            h('span', {
                                class: 'vxe-table--cell-main-area'
                            }),
                            h('span', {
                                class: 'vxe-table--cell-copy-area'
                            }),
                            h('span', {
                                class: 'vxe-table--cell-extend-area'
                            }),
                            h('span', {
                                class: 'vxe-table--cell-multi-area'
                            }),
                            h('span', {
                                class: 'vxe-table--cell-active-area'
                            }),
                            h('span', {
                                class: 'vxe-table--cell-col-status-area'
                            })
                        ])
                        : renderEmptyElement($xeTable)
                ])
            ])
        ]);
    },
    methods: {
        uploadColumn() {
            const { $parent: $xetable } = this;
            this.headerColumn = $xetable.isGroup ? convertHeaderColumnToRows(this.tableGroupColumn) : [];
        }
    }
};
